import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: '_easy_substractions_only_positive',
    dependencies: []
})


function common (q, a, b) {
    q.addText(a + ' - ' + b + ' = ?')
    q.answer = a - b
}


level.addQuestion({
    generator: function (q) {
        let delta = random.fairChoiceInt(1, 5, {name: 'b'})
        common(q, random.fairChoiceInt(1, 5, {name: 'a'}) + delta, delta)
    },
    times: 3
})


export default level

